import React from 'react'
import SearchIconSVG from "../../../assets/icons/search-icon.svg"
import { combineClasses } from '../../../utils/combineClasses'
export const SearchIcon: React.FC<{className?: string}> = ({className=""}) => {
  return (
    <img src={SearchIconSVG} alt="" className={combineClasses("w-[20px] h-[20px] cursor-pointer", className)} />
  )
}
